import { useMemo } from 'react'
import type { AdminSession } from '@/types'

interface SessionsByUser {
  filteredSessions: AdminSession[]
  sessionsByUser: Record<string, AdminSession[]>
}

/** Filters sessions by username/IP substring, then groups the result by user id. */
export function useSessionsByUser(sessions: AdminSession[], filter: string): SessionsByUser {
  return useMemo(() => {
    const filteredSessions = filter
      ? sessions.filter(
          (session) =>
            session.username?.toLowerCase().includes(filter.toLowerCase()) || session.ipAddress?.includes(filter),
        )
      : sessions

    const sessionsByUser = filteredSessions.reduce<Record<string, AdminSession[]>>((acc, session) => {
      const key = session.userId.toString()
      acc[key] = [...(acc[key] ?? []), session]
      return acc
    }, {})

    return { filteredSessions, sessionsByUser }
  }, [sessions, filter])
}
